import type { Listing } from '@thevillages/schemas';

import { Component, inject, input } from '@angular/core';

import { StateService } from '../../../services/state/state';
import { MapListingPopoverHome } from './home/home';
import { MapListingPopoverHomesite } from './homesite/homesite';

@Component({
  imports: [MapListingPopoverHome, MapListingPopoverHomesite],
  selector: 'app-map-listing-popover',
  templateUrl: './listing-popover.html',
})
export class MapListingPopover {
  protected readonly stateService = inject(StateService);

  public readonly listing = input.required<Listing>();
}
